export const ADD_ALIAS = 'ADD_ALIAS';
export const UPDATE_ALIAS = 'UPDATE_ALIAS';

export const SET_CONFLUENCE_ALIASES = 'SET_CONFLUENCE_ALIASES';

export const SET_CONFLUENCE_ALIAS = 'SET_CONFLUENCE_ALIAS';

export const DELETE_ALIAS = 'DELETE_ALIAS';
